<template>
  <section :class="[className]">
    <div class="col-md-12 no-padding">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  props: ['className'],
}
</script>



// WEBPACK FOOTER //
// src/components/base/Section.vue